import { render, staticRenderFns } from "./Hairdressers.vue?vue&type=template&id=5a199902&lang=pug&"
import script from "./Hairdressers.vue?vue&type=script&lang=ts&"
export * from "./Hairdressers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports